import { getServiceName } from '@repo/utils';

import BubblechatSceneIcon from './BubblechatSceneIcon';
import TingleSceneIcon from './TingleSceneIcon';
import { IConDefaultType } from '../../types';

export enum SceneIconVariant {
  DEFAULT = 'default',
  CARTOON = 'cartoon',
  CARTOON_DARK = 'cartoon_dark',
}

export type ISceneIconProps = IConDefaultType & {
  variant?: SceneIconVariant;
};

const SceneIcon = (props: ISceneIconProps) => {
  const serviceName = getServiceName();
  switch (serviceName) {
    case 'tingle':
      return <TingleSceneIcon {...props} />;
    default:
      return <BubblechatSceneIcon {...props} />;
  }
};

export default SceneIcon;
